/**
 * B545 — the merge rule on the BUYER surface: the same product, class and
 * departure added again JOINS the line already in the cart (370-2's note;
 * the deployed cart drew a second `1 × Adult` card). The wire's cart.add
 * never merges (B391 — the till's `+` is set_quantity), so the storefront
 * plans the join: set_quantity(existing + added) on the matching line.
 */
export interface MergeableLine {
  readonly lineId: string;
  readonly productId: string;
  readonly variantId?: string | undefined;
  readonly slotId?: string | undefined;
  readonly quantity: number;
}

export interface AddLine {
  readonly productId: string;
  readonly variantId: string;
  readonly quantity: number;
  readonly slotId?: string;
}

export type MergeStep = { readonly kind: "add"; readonly line: AddLine } | { readonly kind: "set"; readonly lineId: string; readonly quantity: number };

export function mergeAddPlan(existing: readonly MergeableLine[], adds: readonly AddLine[]): readonly MergeStep[] {
  const counts = new Map(existing.map((l) => [l.lineId, l.quantity]));
  return adds.map((add): MergeStep => {
    const match = existing.find((l) => l.productId === add.productId && l.variantId === add.variantId && l.slotId === add.slotId);
    if (match === undefined) return { kind: "add", line: add };
    const quantity = (counts.get(match.lineId) ?? match.quantity) + add.quantity;
    counts.set(match.lineId, quantity);
    return { kind: "set", lineId: match.lineId, quantity };
  });
}
